export type UnassignedSortOrder = "position" | "dateAsc" | "dateDesc";

export const UNASSIGNED_COLUMN_IDENTITY = 0;

export const UNASSIGNED_SORT_STORAGE_KEY_PREFIX = "unassignedSort_";

export function isUnassignedSortOrder(value: string | null): value is UnassignedSortOrder {
  return value === "position" || value === "dateAsc" || value === "dateDesc";
}
